// frontend/src/lib/counts.ts
// Helpers for reading and rendering counts per the per-app config.counts schema.
// The shape of an event's `counts` object varies by app — these helpers
// abstract over that variability so components and build scripts don't
// hardcode field names.

import type { AppConfig } from './config';

export function getPrimaryCount(
  counts: Record<string, number | undefined> | undefined | null,
  cfg: AppConfig,
): number {
  const primary = cfg.counts.fields.find((f) => f.primary);
  if (!primary) return 0;
  return counts?.[primary.id] ?? 0;
}

export interface FormattedCount {
  id: string;
  label: string;
  value: number;
}

export function formatCounts(
  counts: Record<string, number | undefined> | undefined | null,
  cfg: AppConfig,
): FormattedCount[] {
  return cfg.counts.fields.map((f) => ({
    id: f.id,
    label: f.label,
    value: counts?.[f.id] ?? 0,
  }));
}
